function replaceHeader() {
  const h1Element = document.querySelector('[data-field="headerText"]');
  if (!h1Element) {
    return;
  }
  const yotpoHeader = document.createElement("p");
  yotpoHeader.innerHTML = h1Element.innerHTML;
  yotpoHeader.setAttribute("data-field", "headerText");
  h1Element.classList.forEach((className) => {
    yotpoHeader.classList.add(className);
  });
  h1Element.replaceWith(yotpoHeader);
  return true;
}

if (!replaceHeader()) {
  const observer = new MutationObserver(function () {
    if (replaceHeader()) {
      observer.disconnect(); // Stop observing once the element is found and replaced
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
